export default "__VITE_ASSET__DYHAf37v__"